import { Injectable, inject } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';

@Injectable({
  providedIn: 'root',
})
export class UpdateCheckService {
  private swUpdate = inject(SwUpdate);

  constructor() {
    this.initializeUpdateCheck();
  }

  private initializeUpdateCheck(): void {
    if (this.swUpdate.isEnabled) {
      this.checkForUpdates();
    }
  }

  /**
   * Verifica se existe uma nova versão disponível
   */
  private checkForUpdates(): void {
    this.swUpdate
      .checkForUpdate()
      .then(() => {
        console.log('✓ Verificação de atualização concluída');
      })
      .catch((error: unknown) => {
        console.error('✗ Erro ao verificar atualizações:', error);
      });
  }

  /**
   * Monitora quando uma atualização fica disponível e a aplica automaticamente
   */
  public initializeAutoUpdate(): void {
    if (this.swUpdate.isEnabled) {
      this.swUpdate.versionUpdates.subscribe((event) => {
        if (event.type === 'VERSION_READY') {
          console.log('⚡ Nova versão disponível:', event.latestVersion);
          this.promptUserAndUpdate();
        } else if (event.type === 'VERSION_INSTALLATION_FAILED') {
          console.error('✗ Falha ao instalar atualização:', event.error);
        }
      });
    }
  }

  /**
   * Exibe notificação ao usuário e recarrega a página com nova versão
   */
  private promptUserAndUpdate(): void {
    const userConfirmed = confirm(
      'Uma nova versão do aplicativo está disponível. Deseja atualizar agora?',
    );

    if (userConfirmed) {
      this.activateUpdate();
    } else {
      // Reoferecer após 10 minutos se o usuário recusar
      setTimeout(
        () => {
          this.promptUserAndUpdate();
        },
        10 * 60 * 1000,
      );
    }
  }

  /**
   * Ativa a atualização e recarrega a página
   */
  private activateUpdate(): void {
    this.swUpdate
      .activateUpdate()
      .then(() => {
        console.log('✓ Atualização ativada com sucesso');
        window.location.reload();
      })
      .catch((error: unknown) => {
        console.error('✗ Erro ao ativar atualização:', error);
      });
  }
}
